export const navigationSegments = {
  search: 'search',
  browse: 'browse',
};
